import { NgModule } from '@angular/core';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { FormsModule } from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import { AuthModule } from '../auth.module';
import { PageLoginPopupsModule } from '../../tools/page-login-popups/page-login-popups.module';

@NgModule({
    declarations: [
        LoginComponent
    ],
    exports: [
        LoginComponent
    ],
    imports: [
        LoginRoutingModule,
        InputTextModule,
        PasswordModule,
        AppConfigModule,
        FormsModule,
        DialogModule,
        ToastModule,
        AuthModule,
        PageLoginPopupsModule
    ]
})
export class LoginModule { }
